/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-03-19 10:21:59
 * @LastEditors: chen
 * @LastEditTime: 2021-03-19 10:22:55
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeScript } from '@angular/platform-browser';

@Pipe({
  name: 'alipay'
})
export class AlipayPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }
  transform(style): SafeScript {
    return this.sanitizer.bypassSecurityTrustScript(style);
  }

}
